import React from 'react';
import PropTypes from 'prop-types';

/**
 * Date Separator Component
 * Renders a floating pill with the date label
 */
export default function DateSeparator({ date }) {
    return (
        <div className="flex justify-center my-6 sticky top-2 z-10">
            <div className="px-4 py-1.5 rounded-full bg-app-surface/90 backdrop-blur-md border border-border-subtle shadow-subtle hover:scale-105 transition-transform cursor-default">
                <span className="text-[10px] font-extrabold uppercase tracking-widest text-text-muted opacity-80">
                    {date}
                </span>
            </div>
        </div>
    );
}

DateSeparator.propTypes = {
    date: PropTypes.string.isRequired
};
